import React from 'react';
import Navbar from '../../Landing/ForecastNestHome/navbar';
import Footer from '../../Landing/ForecastNestHome/footer';
import PricingSection from '../../Landing/ForecastNestHome/pricing';
import ResearchDisclaimer from '../../../Components/Common/ResearchDisclaimer';
import { Col, Container, Row } from 'reactstrap';

/**
 * /pricing — the same section the landing page carries, on a page of its own.
 *
 * Worth a route rather than only an anchor, because this is the link that gets
 * sent: to a payment provider reviewing the account, in a reply to "what does
 * it cost", from the profile page when somebody has no plan. "#pricing" on the
 * home page works only if the reader lands at the top and scrolls, and it puts
 * a marketing hero in front of the answer they asked for.
 *
 * One component, rendered in two places, so the price cannot say one thing here
 * and another there.
 */
const PricingPage = () => {
    document.title = 'Pricing | ForecastNest';

    return (
        <React.Fragment>
            <div className="layout-wrapper landing">
                <Navbar />
                {/* The fixed navbar overlays the top of the page; this clears
                    it. Bootstrap's spacing utilities are !important and would
                    replace the section's own padding rather than add to it. */}
                <div style={{ paddingTop: 72 }}>
                    <PricingSection />
                    <Container className="pb-5">
                        <Row className="justify-content-center">
                            <Col lg={8}><ResearchDisclaimer /></Col>
                        </Row>
                    </Container>
                </div>
                <Footer />
            </div>
        </React.Fragment>
    );
};

export default PricingPage;
